import { render, staticRenderFns } from "./ModalANS.vue?vue&type=template&id=4959c6fc&scoped=true"
import script from "./ModalANS.vue?vue&type=script&lang=js"
export * from "./ModalANS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959c6fc",
  null
  
)

export default component.exports